import { TextField } from '@mui/material';
import React from 'react';

interface Props {
  name: string;
  onNameChange: (val: string) => void;
}

export default React.memo(function NameField({ name, onNameChange }: Props) { 
  return (
    <>
      <div
        className='w-100'>
        {' '}
        <TextField
          inputProps={{ style: { fontSize: 14 } }}
          InputLabelProps={{ style: { fontSize: 14 } }}
          onChange={(e) => onNameChange(e.target.value)}
          label="Identifier"
          className="w-100"
          value={name}
          autoComplete="off"
        />
      </div>
    </>
  );
});
